import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51fc9697")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_disqus = _resolveComponent("disqus", true)!

  return (_openBlock(), _createBlock("section", {
    class: ["module", [ _ctx.module.type ]]
  }, [
    _createVNode(_component_disqus, {
      shortname: "roberttolton",
      "page-config": _ctx.disqusPageConfig
    }, null, 8, ["page-config"])
  ], 2))
})